import { css } from 'styled-components';
import { CFTokens } from '../../../tokens';
import { CFBaseListItemTokens } from './';
export const dividerPosition = ({ $extendBorders, $position, }) => css `
  left: ${$extendBorders ? 0 : CFBaseListItemTokens.INLINE_PADDING}px;
  right: ${$extendBorders ? 0 : CFBaseListItemTokens.INLINE_PADDING}px;
  ${$position === 'top'
    ? css `
        top: 0;
      `
    : css `
        bottom: 0;
      `};
`;
export const dotPosition = () => {
    const leftOffset = CFBaseListItemTokens.INLINE_PADDING / 2 - CFBaseListItemTokens.DOT_SIZE / 2;
    return css `
    top: 50%;
    left: ${leftOffset}px;
  `;
};
export const rootInteractionsNative = ({ $disabled, $extendBorders, $pressed, $selected, }) => {
    if ((!$disabled && $pressed) || $selected) {
        return css `
      border-radius: ${$extendBorders ? 0 : CFTokens.BORDER_RADIUS.B}px;
      background-color: ${$selected
            ? CFBaseListItemTokens.BACKGROUND_SELECTED
            : CFBaseListItemTokens.BACKGROUND_HOVER};
    `;
    }
    return null;
};
export const rootInteractionsWeb = ({ $extendBorders, $disabled, $isInteractive, $selected, }) => {
    if (!$isInteractive)
        return null;
    return css `
    background-color: ${$selected
        ? CFBaseListItemTokens.BACKGROUND_SELECTED
        : 'transparent'};
    border-radius: ${$extendBorders ? 0 : CFTokens.BORDER_RADIUS.B}px;
    transition-duration: 100ms;
    transition-property: background-color;

    &:focus-visible,
    &:focus-within {
      outline: 2px solid ${CFTokens.COLOR.INTERACTIVE_FOCUS_PRIMARY};
    }

    &:hover {
      ${!$disabled &&
        css `
        background-color: ${$selected
            ? CFBaseListItemTokens.BACKGROUND_SELECTED_HOVER
            : CFBaseListItemTokens.BACKGROUND_HOVER};
      `}
      cursor: ${$disabled ? 'initial' : 'pointer'};
    }
  `;
};
export const rootSizeNative = ({ $extendIntoGutters, }) => $extendIntoGutters
    ? css `
        margin-left: -${CFBaseListItemTokens.INLINE_PADDING}px;
        margin-right: -${CFBaseListItemTokens.INLINE_PADDING}px;
      `
    : css `
        width: 100%;
      `;
export const rootSizeWeb = ({ $extendIntoGutters }) => $extendIntoGutters
    ? css `
        margin-left: -${CFBaseListItemTokens.INLINE_PADDING}px;
        margin-right: -${CFBaseListItemTokens.INLINE_PADDING}px;
        width: calc(100% + 2 * ${CFBaseListItemTokens.INLINE_PADDING}px);
      `
    : css `
        width: 100%;
      `;
